class CartDrawer extends HTMLElement {
  constructor() {
    super();
    this._closedByUser = false; // Bug 2 fix: track user dismissal

    this.addEventListener('keyup', (evt) => {
      if (evt.code === 'Escape') {
        this._closedByUser = true;
        this.close();
      }
    });

    const overlay = this.querySelector('#CartDrawer-Overlay');
    overlay.addEventListener('click', this.close.bind(this));
    overlay.addEventListener('touchend', (evt) => {
      evt.preventDefault(); // Bug 1 fix: stop browser synthesising a click ~300ms later
      this._closedByUser = true;
      this.close();
    });

    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    this._closedByUser = false; // Bug 2 fix: reset flag on intentional open
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);

    const overlay = this.querySelector('#CartDrawer-Overlay');
    if (overlay) overlay.style.display = 'block';

    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        this.classList.add('animate', 'active');
      });
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this._closedByUser = true; // Bug 2 fix: mark that the user dismissed the drawer
    this.classList.remove('active', 'animate');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');

    const overlay = this.querySelector('#CartDrawer-Overlay');
    if (overlay) overlay.style.display = 'none';
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement) return;
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    setTimeout(() => {
      const overlay = this.querySelector('#CartDrawer-Overlay');
      const newOverlay = overlay.cloneNode(true);
      overlay.parentNode.replaceChild(newOverlay, overlay);
      newOverlay.addEventListener('click', this.close.bind(this));
      newOverlay.addEventListener('touchend', (evt) => {
        evt.preventDefault(); // Bug 1 fix: repeated here for the cloned overlay
        this._closedByUser = true;
        this.close();
      });

      if (!this._closedByUser) { // Bug 2 fix: only open if user hasn't already dismissed it
        this.open();
      }
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

document.addEventListener('click', (event) => {
  const button = event.target.closest('[data-sd-cart-upsell-add]');
  if (!button) return;

  event.preventDefault();

  const variantId = button.dataset.variantId;
  const cartDrawer = document.querySelector('cart-drawer');
  if (!variantId || !cartDrawer) return;

  button.disabled = true;
  button.classList.add('is-loading');
  const originalText = button.textContent;
  button.textContent = 'ADDING';

  const body = JSON.stringify({
    id: Number(variantId),
    quantity: 1,
    sections: cartDrawer.getSectionsToRender().map((section) => section.id),
    sections_url: window.location.pathname,
  });

  fetch(routes.cart_add_url, { ...fetchConfig('javascript'), body })
    .then((response) => response.json())
    .then((parsedState) => {
      if (parsedState.status) {
        button.textContent = originalText;
        return;
      }

      cartDrawer.classList.remove('is-empty');
      cartDrawer.renderContents(parsedState);
    })
    .catch(() => {
      button.textContent = originalText;
    })
    .finally(() => {
      button.classList.remove('is-loading');
      button.disabled = false;
    });
});

(function () {
  const FREE_GIFT_PROPERTY = '_sd_free_gift';
  const FREE_GIFT_CHOICE_STORAGE_KEY = 'sd_free_gift_variant_id';
  let syncing = false;
  let syncTimer = null;

  function freeGiftConfig() {
    const el = document.querySelector('[data-sd-free-gift-config]');
    if (!el) return null;

    const variantIds = (el.dataset.variantIds || '')
      .split(',')
      .map((id) => Number(id))
      .filter(Boolean);
    const selectedVariantId = Number(el.dataset.variantId || 0);
    const storedVariantId = Number(window.localStorage.getItem(FREE_GIFT_CHOICE_STORAGE_KEY) || 0);
    const storedVariantIsAllowed = variantIds.includes(storedVariantId);
    const variantId = storedVariantIsAllowed ? storedVariantId : selectedVariantId;

    return {
      enabled: el.dataset.enabled === 'true',
      valid: el.dataset.valid === 'true',
      variantId,
      variantIds,
      requiresChoice: el.dataset.requiresChoice === 'true',
      threshold: Number(el.dataset.threshold || 0),
    };
  }

  function isFreeGiftItem(item) {
    return item && item.properties && item.properties[FREE_GIFT_PROPERTY] === 'true';
  }

  function drawerSections() {
    const drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.getSectionsToRender === 'function') {
      return drawer.getSectionsToRender().map((section) => section.id);
    }

    return ['cart-drawer', 'cart-icon-bubble'];
  }

  function renderCartSections(parsedState) {
    const drawer = document.querySelector('cart-drawer');
    if (drawer && parsedState && parsedState.sections && typeof drawer.renderContents === 'function') {
      drawer.classList.toggle('is-empty', parsedState.item_count === 0);
      drawer.renderContents(parsedState);
      return;
    }

    const drawerItems = document.querySelector('cart-drawer-items');
    if (drawerItems && typeof drawerItems.onCartUpdate === 'function') {
      drawerItems.onCartUpdate();
    }
  }

  function updateGiftLines(updates, options = {}) {
    return fetch(routes.cart_update_url, {
      ...fetchConfig('javascript'),
      body: JSON.stringify({
        updates,
        ...(options.render === false
          ? {}
          : {
              sections: drawerSections(),
              sections_url: window.location.pathname,
            }),
      }),
    })
      .then((response) => response.json())
      .then((parsedState) => {
        if (options.render === false) return parsedState;

        renderCartSections(parsedState);
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'sd-free-gift', cartData: parsedState, variantId: null });
      });
  }

  function addGift(variantId) {
    return fetch(routes.cart_add_url, {
      ...fetchConfig('javascript'),
      body: JSON.stringify({
        id: variantId,
        quantity: 1,
        properties: {
          [FREE_GIFT_PROPERTY]: 'true',
        },
        sections: drawerSections(),
        sections_url: window.location.pathname,
      }),
    })
      .then((response) => response.json())
      .then((parsedState) => {
        if (parsedState.status) return;

        renderCartSections(parsedState);
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'sd-free-gift', cartData: parsedState, variantId });
      });
  }

  function syncFreeGift() {
    if (syncing) return Promise.resolve();

    const config = freeGiftConfig();
    syncing = true;

    return fetch(`${routes.cart_url}.js`, { headers: { Accept: 'application/json' } })
      .then((response) => response.json())
      .then((cart) => {
        const giftItems = cart.items.filter(isFreeGiftItem);
        const qualifyingSubtotal = cart.items.reduce((total, item) => {
          return isFreeGiftItem(item) ? total : total + item.final_line_price;
        }, 0);

        const shouldRemoveAll = !config || !config.enabled || !config.valid || qualifyingSubtotal < config.threshold;
        if (shouldRemoveAll) {
          if (!giftItems.length) return null;

          const updates = {};
          giftItems.forEach((item) => {
            updates[item.key] = 0;
          });
          return updateGiftLines(updates);
        }

        const selectedVariantId = Number(config.variantId || 0);
        if (!selectedVariantId) {
          if (!giftItems.length) return null;

          const updates = {};
          giftItems.forEach((item) => {
            updates[item.key] = 0;
          });
          return updateGiftLines(updates);
        }

        const matchingGift = giftItems.find((item) => Number(item.variant_id) === config.variantId);
        const updates = {};

        giftItems.forEach((item) => {
          if (!config.variantIds.includes(Number(item.variant_id)) || Number(item.variant_id) !== config.variantId || item.key !== (matchingGift && matchingGift.key)) {
            updates[item.key] = 0;
          }
        });

        if (matchingGift && matchingGift.quantity !== 1) {
          updates[matchingGift.key] = 1;
        }

        if (Object.keys(updates).length) {
          const shouldAddSelectedGift = !matchingGift || updates[matchingGift.key] === 0;
          return updateGiftLines(updates, shouldAddSelectedGift ? { render: false } : {}).then(() => {
            if (shouldAddSelectedGift) return addGift(config.variantId);
            return null;
          });
        }

        if (!matchingGift) {
          return addGift(config.variantId);
        }

        return null;
      })
      .catch((error) => {
        console.error('[Salford] Free gift sync failed:', error);
      })
      .finally(() => {
        syncing = false;
      });
  }

  function scheduleFreeGiftSync(delay = ON_CHANGE_DEBOUNCE_TIMER) {
    window.clearTimeout(syncTimer);
    syncTimer = window.setTimeout(syncFreeGift, delay);
  }

  document.addEventListener('change', (event) => {
    const select = event.target.closest('[data-sd-free-gift-select]');
    if (!select) return;

    event.stopPropagation();

    const variantId = Number(select.value || 0);
    if (variantId) {
      window.localStorage.setItem(FREE_GIFT_CHOICE_STORAGE_KEY, String(variantId));
    } else {
      window.localStorage.removeItem(FREE_GIFT_CHOICE_STORAGE_KEY);
    }

    scheduleFreeGiftSync(0);
  }, { capture: true });

  document.addEventListener('DOMContentLoaded', () => scheduleFreeGiftSync(100));

  subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
    if (event && event.source === 'sd-free-gift') return;
    scheduleFreeGiftSync();
  });
})();

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);
